
import React, {useContext, useEffect, useState} from 'react';
import {Context} from "../../../../index";
import {observer} from "mobx-react-lite";
import './MyOffersPage.css';
import {getOrdersByUserId} from "../../../../http/userAPI";
import OneOffer from "./OneOffer/OneOffer";

const MyOffers = observer((props) => {

    const {user} = useContext(Context)

    const principalId = user.isAuth === true && Number.isSafeInteger(user.user?.id) && user.user.id > 0 ? user.user.id : null;
    const active = props.active === 'active';
    const [snapshot, setSnapshot] = useState(null);
    const owned = active && principalId !== null && snapshot?.principalId === principalId ? snapshot : null;
    const userOrders = owned?.orders;

    useEffect(() => {
        let current = true;
        setSnapshot(null);
        if (active && principalId !== null) {
            const stillOwned = () => current && user.isAuth === true && user.user?.id === principalId;
            getOrdersByUserId(principalId).then(response => {
                if (!stillOwned()) return;
                if (!Array.isArray(response)) throw new Error('Unavailable history');
                setSnapshot({principalId, orders: response, error: false});
            }).catch(() => {if (stillOwned()) setSnapshot({principalId, orders: null, error: true});});
        }
        return () => {current = false;};
    }, [active, principalId, user]);



    return (
        <div className={"my_offers_container " +props.active}>
            <div className={"your_offers_title"}>Ваши покупки в интернет-магазине:</div>
            <div className={"my_offers_for_items_container"}>
                {
                    owned?.error ? <div className="user_lc_no_my_offers">Не удалось загрузить заказы. Попробуйте позже.</div> :
                    userOrders && userOrders[0] ?
                        userOrders.map((item,index) =>
                            <OneOffer key={`${principalId}:${item.id}`} item={item} />
                        )
                        :
                        userOrders && <div className={"user_lc_no_my_offers"}>
                            К сожалению, у Вас нет ни одной покупки.
                        </div>
                }
            </div>
        </div>
    );
});

export default MyOffers;
